// src/components/SwitchCase.tsx
import { isNil } from "@teamsparta/utils";
import { Fragment, jsx } from "react/jsx-runtime";
function SwitchCase({
  value,
  cases,
  defaultComponent = null
}) {
  if (isNil(value)) return /* @__PURE__ */ jsx(Fragment, { children: defaultComponent });
  return /* @__PURE__ */ jsx(Fragment, { children: cases[value] ?? defaultComponent });
}

export {
  SwitchCase
};
